import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

const FIELDS = [["name", "Name"], ["phone", "Phone"], ["email", "Email"], ["street", "Mailing street"], ["city", "City"], ["state", "State"], ["zip", "ZIP"], ["property_address", "Property address"], ["notes", "Notes"]];
const blank = { name: "", phone: "", email: "", street: "", city: "", state: "FL", zip: "", property_address: "", notes: "" };

export const PmLeadDialog = ({ open, onClose, lead, kind, onSaved }) => {
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setF(lead ? { ...blank, ...Object.fromEntries(Object.keys(blank).map((k) => [k, lead[k] || ""])), email_bounced: !!lead.email_bounced } : blank); }, [lead, open]);
  const save = async () => {
    setBusy(true);
    try {
      if (lead) await api.put(`/pm/leads/${lead.id}`, { ...f, kind });
      else await api.post("/pm/leads", { ...f, kind });
      toast.success(lead ? "Lead updated" : "Lead added"); onSaved(); onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="pm-lead-dialog">
        <DialogHeader><DialogTitle>{lead ? "Edit lead" : "Add lead"}</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          {FIELDS.map(([k, l]) => (
            <div key={k} className={k === "property_address" || k === "notes" ? "sm:col-span-2" : ""}><Label>{l}</Label>
              <Input value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1" data-testid={`pm-lead-field-${k}`} /></div>
          ))}
          {lead && <div className="flex items-center gap-2 sm:col-span-2"><Switch checked={!!f.email_bounced} onCheckedChange={(v) => setF({ ...f, email_bounced: v })} data-testid="pm-lead-bounced" /><span className="text-sm">Email bounced (send a one-time postcard instead)</span></div>}
        </div>
        <DialogFooter><Button variant="ghost" onClick={onClose} data-testid="pm-lead-cancel">Cancel</Button>
          <Button onClick={save} disabled={busy || !f.name.trim()} data-testid="pm-lead-save">{busy ? "Saving..." : "Save"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
